import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
// import { EstudianteRequerimientosDTO } from '../../../../core/models/titulacion/estudianteRequerimientos-DTO';
import { SolicitudRequisitosDTO } from '../../../../core/models/titulacion/solicitudRequisitos-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class SolicitudRequisitoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getEstudianteRequisitosService() {
        return this.http.get<BodyListResponse<SolicitudRequisitosDTO>>(
            API_URL + '/api/v1/estudianteRequisitos/todos'
        );
    }

    guardarEstudianteRequisitosService(estudianteRequerimientosDTO: SolicitudRequisitosDTO) {
        return this.http.post(API_URL + '/api/v1/estudianteRequisitos', estudianteRequerimientosDTO);
    }

    getEstudianteRequisitosPorCodigoRequisitosEstudianteService(codigoRequerimientoEstudiante: string) {
        return this.http.get<BodyResponse<SolicitudRequisitosDTO>>(
            API_URL + '/api/v1/estudianteRequisitos/' + codigoRequerimientoEstudiante
        );
    }
}
